import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const DEVELOP_ROUTES: Routes = [
  {
    path: 'component-playground',
    loadComponent: () => import('./component-playground/component-playground.component').then(m => m.ComponentPlaygroundComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  }
];
